import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation(["marketing", "common"]);
  const paragraphs = t("about.paragraphs", {
    returnObjects: true,
  }) as string[];

  return (
    <div data-testid="page-about" className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="font-display text-3xl font-black">{t("about.title")}</h1>
      <div className="mt-6 space-y-4 text-ink-soft">
        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
};

export default About;
